import { defineAction } from '~/prix'
import citizenGeocodeAction from './citizenGeocode.action.json'
import { z } from 'zod'

const citizenGeocodeDefinition = defineAction({
  ...citizenGeocodeAction,
  input: z.object({
    debug: z.boolean().optional(),
    testOnly: z.boolean().optional(),
    metricsOnly: z.boolean().optional(),
    sourceWhere: z.string().optional(),
    geocodeWhere: z.string().optional(),
  }),
  output: z.object({
    metrics: z
      .object({
        sourceRows: z.number(),
        protectedManualGeoRows: z.number(),
        sourceRowsByDataSourceId: z.record(z.number()),
        safeResidenceMatches: z.object({
          total: z.number(),
          source: z.number(),
          cpf: z.number(),
          cns: z.number(),
        }),
        withoutSafeResidence: z.number(),
        blockedResidenceMatches: z.object({
          crossClient: z.number(),
          ambiguousSameClient: z.number(),
          missingDataSourceClient: z.number(),
        }),
        addressGeocoding: z.object({
          attempted: z.number(),
          skippedWithoutAddressCore: z.number(),
          succeeded: z.number(),
          failed: z.number(),
        }),
        fallbackAvailability: z.object({
          community: z.number(),
          neighborhood: z.number(),
          municipality: z.number(),
          none: z.number(),
        }),
        fallbackUsed: z.object({
          community: z.number(),
          neighborhood: z.number(),
          municipality: z.number(),
          none: z.number(),
        }),
        writtenRows: z.number(),
      })
      .optional(),
  }),
})

export default citizenGeocodeDefinition
